// extracted by mini-css-extract-plugin
module.exports = {"loginTitle":"XFZzowd8bh4nHnZsSHmrV","loginControls":"x-i-qNfUKwHxFtrSgdZ10","forgottenPassword":"_2TtsNx4q9jPFt6MAyLXS0d"};